import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from "@angular/core";
import { RouterModule } from "@angular/router";
import { SupplierEstimateSummary } from "../core/api.service";

const STATUS_LABELS: Record<string, string> = {
  pending: "Pending Quote",
  submitted: "Quote Submitted",
  approved: "Approved",
  rejected: "Rejected",
  paid: "Paid",
};

@Component({
  selector: "app-orders-list",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule],
  templateUrl: "./orders-list.component.html",
  styleUrls: ["./orders-list.component.scss"],
})
export class OrdersListComponent {
  readonly estimates = input.required<SupplierEstimateSummary[]>();
  readonly title = input.required<string>();
  readonly emptyMessage = input("No orders yet.");
  readonly loading = input(false);
  readonly error = input<string | null>(null);

  readonly pageSize = 10;
  readonly search = signal("");
  readonly page = signal(0);

  private readonly filtered = computed(() => {
    const query = this.search().trim().toLowerCase();
    const all = this.estimates();
    if (!query) return all;
    return all.filter((e) =>
      [e.name, e.status, e.supplierQuoteStatus]
        .filter(Boolean)
        .join(" ")
        .toLowerCase()
        .includes(query),
    );
  });

  readonly total = computed(() => this.filtered().length);
  readonly pageCount = computed(() =>
    Math.max(1, Math.ceil(this.filtered().length / this.pageSize)),
  );

  readonly pageRows = computed(() => {
    const page = Math.min(this.page(), this.pageCount() - 1);
    const start = page * this.pageSize;
    return this.filtered().slice(start, start + this.pageSize);
  });

  setSearch(value: string) {
    this.search.set(value);
    this.page.set(0);
  }

  setPage(delta: number) {
    this.page.set(
      Math.max(0, Math.min(this.page() + delta, this.pageCount() - 1)),
    );
  }

  statusLabel(status: string): string {
    return STATUS_LABELS[status] ?? status;
  }
}
